/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Badge } from '@mantine/core';
import { MRT_ColumnDef } from 'mantine-react-table';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CustomTable, DefaultValue } from '../../../../../components/core/CustomTable/CustomTable';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { ProposalSearchResponseType } from '../../../../../models/core/proposals.type';
import { formatDateToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: (
    | ProposalSearchResponseType & {
        validadeFormatada?: string;
        dataInicialFormatada?: string;
        dataFinalFormatada?: string;
      }
  )[];
  confirmActionResult(item: ProposalSearchResponseType, action: string, confirmed: boolean): void;
};
export default function DataView(props: DataViewProps) {
  const columns = useMemo<MRT_ColumnDef<ProposalSearchResponseType>[]>(
    () => [
      {
        header: '#',
        id: 'idProposta',
        accessorKey: 'idProposta',
        sortingFn: (a, b) => a.original.idProposta - b.original.idProposta,
        Cell: ({ row }) => (
          <Link to={`./${row.original.idProposta}`} target="_blank">
            {row.original.idProposta}
          </Link>
        ),
        size: 60,
      },
      {
        header: 'Tipo',
        accessorKey: 'propostaTipo',
        sortingFn: (a, b) => a.original.propostaTipo.localeCompare(b.original.propostaTipo),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Empresa',
        id: 'empresa',
        accessorFn: (row) => row.empresa,
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Cliente',
        id: 'cliente',
        accessorFn: (row) =>
          `${row.clienteNomeFantasia ?? ''}|${row.clienteRazaoSocial ?? ''}|${row.clienteNome ?? ''}|${
            row.clienteCNPJ ?? ''
          }|${row.clienteCPF ?? ''}`,
        sortingFn: (a, b) =>
          (
            a.original.clienteNomeFantasia ||
            a.original.clienteRazaoSocial ||
            a.original.clienteNome ||
            ''
          ).localeCompare(
            b.original.clienteNomeFantasia || b.original.clienteRazaoSocial || b.original.clienteNome || ''
          ),
        Cell: ({ row }) => {
          const data = row.original;
          return data.clienteCNPJ ? (
            <ProfileCardLink
              id={data.idCliente.toString()}
              name={data.clienteNomeFantasia || data.clienteRazaoSocial || '-'}
              nameSize="sm"
              description={data.clienteNomeFantasia ? data.clienteRazaoSocial : data.clienteCNPJ}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          ) : (
            <ProfileCardLink
              id={data.idCliente.toString()}
              name={data.clienteNome || '-'}
              nameSize="sm"
              description={data.clienteCPF}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          );
        },
      },
      {
        header: 'Gerenciador',
        id: 'gerenciador',
        accessorFn: (row) =>
          `${row.gerenciadorNomeFantasia ?? ''}|${row.gerenciadorRazaoSocial ?? ''}|${
            row.gerenciadorNome ?? ''
          }|${row.gerenciadorCNPJ ?? ''}|${row.gerenciadorCPF ?? ''}`,
        sortingFn: (a, b) =>
          (
            a.original.gerenciadorNomeFantasia ||
            a.original.gerenciadorRazaoSocial ||
            a.original.gerenciadorNome ||
            ''
          ).localeCompare(
            b.original.gerenciadorNomeFantasia ||
              b.original.gerenciadorRazaoSocial ||
              b.original.gerenciadorNome ||
              ''
          ),
        Cell: ({ row }) => {
          const data = row.original;
          if (!data.gerenciadorCNPJ) return '-';
          return (
            <ProfileCardLink
              id={data.idGerenciador!.toString()}
              name={data.gerenciadorNomeFantasia || data.gerenciadorRazaoSocial || '-'}
              nameSize="sm"
              description={data.gerenciadorNomeFantasia ? data.gerenciadorRazaoSocial : data.gerenciadorCNPJ}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          );
        },
      },
      {
        header: 'Status',
        accessorKey: 'propostaStatus',
        sortingFn: (a, b) => a.original.propostaStatus.localeCompare(b.original.propostaStatus),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Validade',
        id: 'validade',
        accessorFn: (row) => new Date(row.validade),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ cell }) =>
          cell.getValue<Date>() ? formatDateToString(cell.getValue<Date>()) : DefaultValue,
      },
      {
        header: 'Data Inicial',
        id: 'dataInicial',
        accessorFn: (row) => new Date(row.dataInicial),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ cell }) =>
          cell.getValue<Date>() ? formatDateToString(cell.getValue<Date>()) : DefaultValue,
      },
      {
        header: 'Data Final',
        id: 'dataFinal',
        accessorFn: (row) => new Date(row.dataFinal),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ cell }) =>
          cell.getValue<Date>() ? formatDateToString(cell.getValue<Date>()) : DefaultValue,
      },
    ],
    []
  );

  return (
    <CustomTable
      columns={columns}
      data={props.data}
      initialState={{
        columnVisibility: { empresa: false, gerenciador: false, dataInicial: false, dataFinal: false },
      }}
      globalFilterFn="contains"
      enableRowActions
      positionActionsColumn="last"
      displayColumnDefOptions={{ 'mrt-row-actions': { size: 210 } }}
      renderRowActions={(renderProps) => (
        <DataViewActions item={renderProps.row.original} confirmActionResult={props.confirmActionResult} />
      )}
    />
  );
}
